const SUCCESS_PRESENTATION_BUILD = "SUCCESS_PRESENTATION_BUILD";
const LOADING_PRESENTATION_BUILD = "LOADING_PRESENTATION_BUILD";

export const TriggerPresentationBuildTypes = {
  SUCCESS_PRESENTATION_BUILD,
  LOADING_PRESENTATION_BUILD
};
